import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  change,
  submit as submitFormAction,
  getFormValues,
  destroy,
} from 'redux-form';
import { Modal, Button, Icon } from 'semantic-ui-react';
import moment from 'moment';

import { createToast, toastType } from 'Common/ToastHelper';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { ApplyCycleMenuFieldEnum as Fields } from 'Common/FieldEnum';
import { APPLY_CYCLE_MENU_FORM_NAME } from 'Common/FormEnum';
import {
  saveCycleMenu,
  applyCycleMenu,
  checkApplyCycleMenu,
} from 'Pages/managemenu/state/editmenu/actions';
import { getIsApplying } from 'Pages/managemenu/state/editmenu/selectors';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';

import { ApplyCycleMenuForm } from './ApplyCycleMenuForm';

import 'Styles/pages/managemenu/manageMenuModal.less';

const now = moment();
class ApplyCycleMenuModal extends Component {
  applyCycleMenu = async (values) => {
    const { applyCycleMenu, saveCycleMenu, isSharedMenu } = this.props;
    if (!isSharedMenu) {
      const saved = await saveCycleMenu();
      if (!saved) {
        createToast(
          toastType.error,
          'Error',
          'An error occured while saving your menu.',
          true
        );
        return;
      }
    }

    const [applied, message] = await applyCycleMenu(values);

    let successMessage = 'Cycle menu has been applied.';
    if (values[Fields.PublishMenu]) {
      successMessage = 'Cycle menu has been applied and published.';
    }

    if (applied) {
      createToast(toastType.success, 'Success', successMessage, true);
      if (message) {
        createToast(toastType.info, 'Warning', message, true);
      }
    }
  };

  checkIfCycleMenuApplied = async () => {
    const {
      checkApplyCycleMenu,
      formValues,
      setNotificationDialog,
    } = this.props;

    const res = await checkApplyCycleMenu(formValues);

    if (res) {
      if (res.hasClosedProdRecords) {
        setNotificationDialog(
          NOTIFICATION_DIALOG_MESSAGES.CYCLE_MENU_HAS_CLOSED_PRODUCTION_RECORDS
        );
      } else if (res.hasProdRecords) {
        setNotificationDialog(
          NOTIFICATION_DIALOG_MESSAGES.CYCLE_MENU_HAS_PRODUCTION_RECORDS
        );
      } else if (res.willOverwrite) {
        setNotificationDialog({
          ...NOTIFICATION_DIALOG_MESSAGES.CYCLE_MENU_WILL_OVERWRITE,
          showCancel: true,
          functionsToRunOnOk: [() => this.applyCycleMenu(formValues)],
          okButtonText: 'Yes',
        });
      } else {
        this.applyCycleMenu(formValues);
      }
    }
  };

  render() {
    const {
      menuId,
      numberOfDaysInCycle,
      headerTitle,
      isApplying,
      modalProps,
      formValues,
      submit,
    } = this.props;
    const { onClose } = modalProps;

    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header">
          {headerTitle}
          <Icon name="close" onClick={onClose} className="manage-menu-close" />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <ApplyCycleMenuForm
            initialValues={{
              [Fields.CycleMenuId]: menuId,
              [Fields.StartDay]: 1,
              [Fields.StartDateTime]: defaultDateFormat(now),
              [Fields.EndDateTime]: defaultDateFormat(now),
              [Fields.SiteIds]: [],
              [Fields.PublishMenu]: false,
              [Fields.NumberOfDaysInCycle]: numberOfDaysInCycle,

              [Fields.PublishToWebsite]: false,
              [Fields.PublishToOMD]: false,
              [Fields.PublishToMobileMenus]: false,
              [Fields.PublishToDigitalDisplays]: false,
              [Fields.PublishToOnlineOrdering]: false,
              [Fields.PublishToGoingGreen]: false,
              [Fields.PublishToDigitalDisplays]: false,
              [Fields.PublishToK12PaymentCenter]: false,
              [Fields.PublishToPOS]: false,
            }}
            formValues={formValues}
            onSubmit={this.checkIfCycleMenuApplied}
          />
        </Modal.Content>
        <Modal.Actions>
          <div className="manage-menu-header-buttons">
            <Button
              className="mnm-button-blue"
              onClick={() => submit(APPLY_CYCLE_MENU_FORM_NAME)}
              loading={isApplying}
              disabled={isApplying}
            >
              Apply
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

const formValueSelector = getFormValues(APPLY_CYCLE_MENU_FORM_NAME);

const mapStateToProps = (state) => ({
  isApplying: getIsApplying(state),
  formValues: formValueSelector(state),
});

const mapDispatchToProps = {
  setNotificationDialog,
  saveCycleMenu,
  applyCycleMenu,
  submit: submitFormAction,
  checkApplyCycleMenu,
  change,
  destroy,
};

const ConnectedApplyCycleMenuModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplyCycleMenuModal);

export { ConnectedApplyCycleMenuModal as ApplyCycleMenuModal };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/ApplyCycleMenuModal.js